const state = {
  groups: [],
  loading_groups: null,
  limit_page_groups: true,
  current_page: 1,
};

const mutations = {
  UPDATE_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_LOADING_GROUPS(state, loading_groups) {
    state.loading_groups = loading_groups;
  },
  LIMIT_PAGE_GROUPS(state, limit_page_groups) {
    state.limit_page_groups = limit_page_groups;
  },
  SET_CURRENT_PAGE(state, current_page) {
    state.current_page = current_page;
  },
};

const getters = {
  getGroups: (state) => {
    return state.groups;
  },
  getCurrentPageGroups: (state) => {
    return state.current_page;
  },
  loadingStateGroups: (state) => {
    return state.loading_groups;
  },
  getLimitPageGroups: (state) => {
    return state.limit_page_groups;
  },
};

export default {
  state,
  mutations,
  getters,
};
